import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import type { CompanyConfigRetire } from "../../generated/core-api";

interface RetireCompanyConfigInput {
  version: number;
  body: CompanyConfigRetire;
}

/**
 * Retire (soft-delete) a specific version of a company configuration. Invalidates the list and
 * the affected config on success. Wraps `api.retireCompanyConfigVersion`.
 */
export function useRetireCompanyConfig(configCode: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ version, body }: RetireCompanyConfigInput) =>
      api.retireCompanyConfigVersion(configCode, version, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companyConfigs"] });
      queryClient.invalidateQueries({
        queryKey: ["companyConfig", configCode],
      });
    },
  });
}
